import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Material UI
import MuiCollapse from '@material-ui/core/Collapse';
// Core components
import Alert from 'components/core/Alert';
import Tooltip from 'components/core/Tooltip';
// Custom
import AppIcon from 'components/icons/AppIcon';
import { CloseIconButton } from 'components/buttons/IconButtons';

const Callout = ({
  severity,
  withInfoIcon,
  title,
  children,
  helpTooltip,
  action,
  closable,
  className,
  centerContent,
}) => {
  // Close management
  const [open, setOpen] = React.useState(true);

  let closeAction;
  if (closable) {
    closeAction = (
      <CloseIconButton
        size="small"
        inherit
        inheritFontSize
        onClick={() => {
          setOpen(false);
        }}
      />
    );
  }

  return (
    <MuiCollapse in={open}>
      <div className={className}>
        <Alert
          severity={severity}
          withInfoIcon={withInfoIcon}
          title={title}
          action={action || closeAction}
          justifyContentCenter={centerContent}
        >
          <div style={{ flex: '1 1 auto', whiteSpace: 'initial' }} className="d-flex align-items-center">
            {children}
            {helpTooltip && (
              <Tooltip content={<LocalizedMessage id={helpTooltip} />}>
                <AppIcon id="btnHelp" primary className="ml-2" />
              </Tooltip>
            )}
          </div>
        </Alert>
      </div>
    </MuiCollapse>
  );
};

Callout.propTypes = {
  severity: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
  withInfoIcon: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  helpTooltip: PropTypes.string,
  action: PropTypes.node,
  centerContent: PropTypes.bool,
  closable: PropTypes.bool,
  className: PropTypes.string,
};

Callout.defaultProps = {
  severity: 'info',
  withInfoIcon: false,
  title: null,
  helpTooltip: null,
  action: null,
  centerContent: false,
  closable: false,
  className: null,
};

module.exports = Callout;



// WEBPACK FOOTER //
// ./components/misc/Callout.js